module.exports = __webpack_public_path__ + "files/3e2b2e91221492e315c4e7970065a287.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-italic.svg
 ** module id = 976
 ** module chunks = 0
 **/